// Content that shipped with the site, in the shape the CMS API returns.
// Shown until the API answers and kept if it never does, so no page can render empty.

export const FALLBACK_HERO = {
  headline_de: 'Zuverlässige Gastgewerbe',
  headline_en: 'Reliable Hospitality',
  subheadline_de: 'Personal-Lösungen',
  subheadline_en: 'Staffing Solutions',
  description_de: 'Gastgewerbebetriebe mit qualifizierten Fachkräften stärken',
  description_en: 'Empowering hospitality businesses with qualified professionals',
  cta_de: 'Personal jetzt anfordern',
  cta_en: 'Request Staff Now',
  video_url: '/media/0f5vqssu_Yetkin_main_video.mp4',
};

export const heroT = (h) => ({
  headline: { de: h.headline_de, en: h.headline_en },
  subheadline: { de: h.subheadline_de, en: h.subheadline_en },
  description: { de: h.description_de, en: h.description_en },
  ctaText: { de: h.cta_de, en: h.cta_en },
});

export const FALLBACK_ABOUT = {
  name: 'Cagdas Yetkin',
  role_de: 'Geschäftsführer',
  role_en: 'CEO',
  image_url: '/media/0dy89oha_Cagdass.png',
  bio_de: [
    'Ausgebildet in der 5-Sterne-Hotellerie, erkannte ich schnell meine Leidenschaft für den Beruf des Hotel-Concierge. Nach meiner Ausbildung folgte ich dem klassischen Weg vom Pagen zum Concierge, bis ich mich schließlich selbstständig machte und seit 2018 mit meinem Team aus erfahrenen Hotel-Concierges mehrere Hotels in Berlin unterstütze.',
    'Geprägt von den Schwierigkeiten der Pandemie, formte sich in mir die Idee der Veränderung, und so fand ich einen Weg, das Geschäft zu erweitern. Seit 2021 unterstütze ich mehrere Hotels in Berlin und Brandenburg im Bereich Housekeeping.',
    'Für mich ist exzellenter Service genauso wichtig wie Sauberkeit und Hygiene im Unternehmen. Ich bin täglich persönlich im Einsatz, um Sie in diesen Bereichen zu unterstützen und stehe im Notfall fast rund um die Uhr zur Verfügung, um jederzeit reagieren zu können.',
  ],
  bio_en: [
    'Trained in 5-star hospitality, I quickly recognized my passion for the hotel concierge profession. After my training, I followed the classic path from page to concierge, until I finally became self-employed and since 2018 have been supporting several hotels in Berlin with my team of experienced hotel concierges.',
    'Shaped by the difficulties of the pandemic, the idea of change formed in me, and so I found a way to expand the business. Since 2021, I have been supporting several hotels in Berlin and Brandenburg in the housekeeping sector.',
    'For me, excellent service is just as important as cleanliness and hygiene in the company. I am personally on duty every day to support you in these areas and am available almost around the clock in emergencies to respond at any time.',
  ],
};

export const FALLBACK_SPONSOR = {
  id: 'sponsor-alba',
  name: 'Alba Berlin',
  logo_url: '/media/6nm3v4qi_ALBA_Logo_RGB.png',
  website_url: 'https://www.albaberlin.de',
  is_sponsor: true,
  description_de: 'Unterstützung des professionellen Basketballs in Berlin mit unserem Engagement für Exzellenz in Hospitality-Dienstleistungen.',
  description_en: 'Supporting professional basketball in Berlin with our commitment to excellence in hospitality services.',
  order: 0,
};

export const FALLBACK_PARTNERS = [
  FALLBACK_SPONSOR,
  { id: 'partner-revo', name: 'Revo Hospitality Group', logo_url: '/media/rid6bj22_REVO.jpeg', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 1 },
  { id: 'partner-louvre', name: 'Louvre Hotels', logo_url: '/media/qmpgw7cq_0Yi5mp69_400x400.jpg', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 2 },
  { id: 'partner-motelone', name: 'Motel One', logo_url: '/media/1wb3r7ka_motel-one-logo-klein.webp', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 3 },
  { id: 'partner-hhotels', name: 'H-Hotels', logo_url: '/media/4vs2c4kn_h-hotels-logo.jpeg', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 4 },
  { id: 'partner-titanic', name: 'Titanic Hotels', logo_url: '/media/bs0kcfuz_titanic-hotels.png', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 5 },
  { id: 'partner-leonardo', name: 'Leonardo Hotels', logo_url: '/media/karv48df_leonardo-hotels-logo.webp', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 6 },
  { id: 'partner-ibis', name: 'Ibis Hotels', logo_url: '/media/apcd57oc_Logo_Ibis-Hotel_2012.png', website_url: '', is_sponsor: false, description_de: '', description_en: '', order: 7 },
];

export const FALLBACK_SETTINGS = {
  name: 'Yetkin Dienstleistungen',
  logo_url: '/media/scugit85_PastedGraphic-1.png',
  tagline_de: 'Exzellenz in Hospitality-Dienstleistungen',
  tagline_en: 'Excellence in Hospitality Services',
  copyright_de: '© 2025 Yetkin Dienstleistungen. Alle Rechte vorbehalten.',
  copyright_en: '© 2025 Yetkin Dienstleistungen. All rights reserved.',
  linkedin_url: '',
  instagram_url: '',
  facebook_url: '',
};

export const FALLBACK_CONTACT = {
  address: 'Berlin, Deutschland',
  phone: '+49 30 123 456 78',
  email: 'info@yetkin-dienstleistungen.de',
  hours_de: 'Mo-Fr 8:00-18:00',
  hours_en: 'Mon-Fri 8:00-18:00',
};

export const FALLBACK_VALUES = [
  { id: 'value-professional', title_de: 'Professionelles Personal', title_en: 'Professional Staff', description_de: 'Qualifizierte und erfahrene Fachkräfte', description_en: 'Qualified and experienced professionals', icon: 'award', order: 0 },
  { id: 'value-reliable', title_de: 'Zuverlässiger Service', title_en: 'Reliable Service', description_de: 'Pünktlich und verlässlich rund um die Uhr', description_en: 'Punctual and reliable around the clock', icon: 'clock', order: 1 },
  { id: 'value-satisfaction', title_de: 'Gäste Zufriedenheit', title_en: 'Guest Satisfaction', description_de: 'Höchste Standards für Ihre Gäste', description_en: 'Highest standards for your guests', icon: 'heart', order: 2 },
  { id: 'value-flexible', title_de: 'Flexible Lösungen', title_en: 'Flexible Solutions', description_de: 'Angepasst an Ihre Bedürfnisse', description_en: 'Adapted to your needs', icon: 'settings', order: 3 },
];

export const valueT = (v) => ({
  title: { de: v.title_de, en: v.title_en },
  description: { de: v.description_de, en: v.description_en },
});
